module.exports = __webpack_public_path__ + "img/mission-connections-small.ab6cbfb9.svg";